import { cn } from './cn';

/** Placeholder block; with `label` it is the named status of what is loading, otherwise decorative. */
export function Skeleton({ className, label }: { className?: string; label?: string }) {
  const base = cn('block animate-pulse rounded-md bg-surface-2', className);
  return label ? <span role="status" aria-label={label} className={base} /> : <span aria-hidden="true" className={base} />;
}
